import {Subheader} from "@/Components";

const ContactPersons = () => {
    const data = [
        {
            name: 'Georg Eriksson',
            title: 'CEO AND SUSTAINABILITY CONSULTANT',
            mail: 'georg.e@dille.se',
            tel: '+46706855939',
            image: '/images/georg.png'
        },
        // {
        //     name: 'Anna Hagelin',
        //     title: 'SUSTAINABILITY CONSULTANT',
        //     mail: 'anna.h@gidas.se',
        //     tel: '+46730270455',
        //     image: '/images/anna.png'
        // }
    ]

    return <div className="flex flex-col items-center w-full md:flex-row md:items-left gap-8 z-20">
        { data.map((item, i) => <div
                className="w-full md:w-1/2 mb-4 md:mb-0 flex flex-col p-[32px] justify-center items-center shadow-xl rounded-[32px] bg-white"
                key={ i }
            >
                <img className="mb-3 w-[150px]" src={ item.image } alt={ item.name } />

                <Subheader className={"text-center"}>{ item.title }</Subheader>
                <h3 className="mb-[10px] font-bold text-[20px] leading-[25px] text-[#363636]">
                    { item.name }
                </h3>

                <ul>
                    <li className="inline-block">
                        <a href={ `mailto:${ item.mail }` } className="mr-4 text-4 text-black leading-[22px]">
                            <img className="inline-block w-[22px] mr-[3px]" src="/images/mail-icon.png" />
                            E-mail
                        </a>
                    </li>
                    <li className="inline-block">
                        <a href={ `tel:${ item.tel }` } className="text-4 text-black leading-[22px]">
                            <img className="inline-block w-[22px] mr-[3px]" src="/images/phone-icon.png" />
                            Call
                        </a>
                    </li>
                </ul>
            </div>
        )}
    </div>
}

export default ContactPersons
